var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dapps && _vm.dapps.length > 0)?_c('div',{staticClass:"dapp-cell-list"},[_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"dapp-cell-list-content"},_vm._l((_vm.dapps),function(dapp){return _c('DAppCell',{key:dapp.key,staticClass:"dapp-cell-list-item mb-2",attrs:{"dapp":dapp,"user-count":dapp.user1d || 0,"shadow":true}})}),1)],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20051e24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/DAppCellList.vue
// module id = null
// module chunks = 